var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"common_panel"},[_c('video',{staticClass:"video",attrs:{"autoplay":"","loop":"","muted":"","src":require("../../../public/video/监控02.mp4")},domProps:{"muted":true}}),_c('div',{staticClass:"close",on:{"click":_vm.onClose}})])
}
var staticRenderFns = []

export { render, staticRenderFns }